import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const PageTitleContext = createContext(null);

export const PageTitleProvider = ({ children }) => {
  const [pageTitleOverride, setPageTitleOverrideState] = useState(null);

  const setPageTitle = useCallback((value) => {
    setPageTitleOverrideState(value === null || value === undefined || value === '' ? null : String(value));
  }, []);

  const value = useMemo(
    () => ({ pageTitleOverride, setPageTitle }),
    [pageTitleOverride, setPageTitle],
  );

  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
};

export const usePageTitle = () => {
  const ctx = useContext(PageTitleContext);
  if (!ctx) {
    throw new Error('usePageTitle must be used within PageTitleProvider');
  }
  return ctx;
};
